import * as yup from 'yup';

import { constants } from 'utils';

export const MAX_SECURITY_CODE_LENGTH = 5;

export const schema = yup.object().shape({
  securityCode: yup
    .string()
    .required(constants.GenericValidationErrors.required)
    .test(
      'validCode',
      constants.GenericValidationErrors.invalidSecurityOrKioskCode,
      securityCode => {
        return securityCode.length === MAX_SECURITY_CODE_LENGTH;
      }
    )
});
